import React from "react";
import {
  Line,
  Bar,
  Pie,
  Doughnut,
  Radar,
  PolarArea,
  Bubble,
  Scatter,
  ChartProps,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  ChartOptions,
  ChartData,
  ChartTypeRegistry,
} from "chart.js";
import { DistributiveArray } from "chart.js/dist/types/utils";

// Registrar todos los componentes que vayas a utilizar
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale
);

const chartTypes = {
  line: Line,
  bar: Bar,
  pie: Pie,
  doughnut: Doughnut,
  radar: Radar,
  polarArea: PolarArea,
  bubble: Bubble,
  scatter: Scatter,
};

type ChartType = keyof typeof chartTypes;

interface IChartProps<T extends ChartType> {
  type: T;
  data: ChartData<T, unknown>;
  options?: ChartOptions<T>;
}

const MChart = <T extends ChartType>({
  type,
  data,
  options,
}: IChartProps<T>) => {
  const ChartComponent = chartTypes[type] as React.ComponentType<ChartProps<T>>;

  return (
    <div>
      <ChartComponent
        type={type}
        data={
          data as ChartData<
            T,
            DistributiveArray<ChartTypeRegistry[T]["defaultDataPoint"]>,
            unknown
          >
        }
        options={options}
      />
    </div>
  );
};

export default MChart;
